import React, { useState, Suspense } from "react";

import Sidebar from "../../components/Sidebar/Sidebar";

import { Outlet } from 'react-router-dom';
import "./mainLayout.css";

function MainLayout({ darkMode, setDarkMode }) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const sidebarWidth = sidebarCollapsed ? "var(--layout-sidebar-width-collapsed)" : "var(--layout-sidebar-width)";

    return (
        <div className="main-layout" style={{
            display: "flex",
            overflow: "hidden",
            height: "100vh",
            width: "100vw",
            background: "transparent",
            "--sidebar-width": sidebarWidth
        }}>

            <div className="main-layout__sidebar">
                <Sidebar darkMode={darkMode} setDarkMode={setDarkMode} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
            </div>

            <div className="main-layout__content">
                <Suspense fallback={<div style={{ padding: "2rem" }} />}>
                    <Outlet />
                </Suspense>
            </div>

        </div>
    );

}

export default MainLayout;